<astral-field-shell [control]="textControl" [forId]="inputId" [helpText]="helpText" [errorMessage]="errorMessage">
  <div class="translate-text-area">
    <textarea
      class="translate-text-area__control"
      [attr.id]="inputId"
      astralFieldAccessibility
      [astralFieldControl]="textControl"
      [astralFieldHelpText]="helpText"
      [astralFieldInputId]="inputId"
      [rows]="rows"
      [formControl]="textControl"
      [placeholder]="textControl.caption | translate"
      [required]="textControl.required ? true : null"
      [readonly]="textControl.isReadonly ? true : null"
      [ngClass]="{ locked: textControl.isReadonly }"
      (blur)="onblur()"
      (focus)="onfocus()"
    ></textarea>

    @if (showTranslate) {
      <astral-translation-action (activate)="translateClicked()"></astral-translation-action>
    }
  </div>
</astral-field-shell>
